module.exports = __webpack_public_path__ + "img/COLLAR LIME.7190fa0.svg";